// extracted by mini-css-extract-plugin
module.exports = {"blogLink":"Blog_blogLink__WMFvN","arrow":"Blog_arrow__9Du1Z"};